import Vue from 'vue'
import VueRouter from 'vue-router'

// 一级页面
import layout from '../views/layout/layout.vue'
import notFound from '../views/notFound/notFound.vue'
import register from '../views/register/register.vue'
import realname from '../views/realname/realname.vue'
import forget from '../views/forget/forget.vue'
import agreement from '../views/agreement/agreement.vue'

// 二级页面
import index from '../views/pages/index/index.vue'
import one from '../views/pages/one/one.vue'
import paper from '../views/pages/paper/paper.vue'
import essay from '../views/pages/essay/essay.vue'
import scene from '../views/pages/scene/scene.vue'
import about from '../views/pages/about/about.vue'
import auction from '../views/pages/auction/auction.vue'
import payment from '../views/pages/payment/payment.vue'
import wechat from '../views/pages/wechat/wechat.vue'
import success from '../views/pages/success/success.vue'

// 个人中心一级页面
import space from '../space/layout/layout.vue'
import phone from '../space/phone/phone.vue'
import email from '../space/email/email.vue'
import password from '../space/password/password.vue'
import address from '../space/address/address.vue'

// 个人中心二级页面
import record from '../space/space/auction/auction.vue'
import particular from '../space/space/particular/particular.vue'
import security from '../space/space/security/security.vue'
import collection from '../space/space/collection/collection.vue'
import footprint from '../space/space/footprint/footprint.vue'
import setting from '../space/space/setting/setting.vue'
import detail from '../space/space/detail/detail.vue'

// 后台管理一级
import admlogin from '../manage/login/login.vue'
import manage from '../manage/layout/layout.vue'

// 后台管理二级页面
import database from '../manage/pages/index/index.vue'
import account from '../manage/pages/account/account.vue'
import users from '../manage/pages/users/users.vue'
import commodity from '../manage/pages/commodity/commodity.vue'
import compile from '../manage/pages/commodity/compile.vue'
import classify from '../manage/pages/classify/classify'
import order from '../manage/pages/order/order.vue'
import orderDetail from '../manage/pages/order/orderDetail.vue'
import earnest from '../manage/pages/earnest/earnest.vue'
import swiper from '../manage/pages/swiper/swiper.vue';
import article from '../manage/pages/article/article.vue'
import issue from '../manage/pages/article/issue.vue'
import category from '../manage/pages/category/category.vue'
import config from '../manage/pages/config/config.vue'
import activity from '../manage/pages/activity/activity.vue'
import activityedit from '../manage/pages/activity/activityedit.vue'
import item from '../manage/pages/item/item.vue'
import itemedit from '../manage/pages/item/itemedit.vue'
import attention from '../manage/pages/attention/attention.vue'
import tags from '../manage/pages/tags/tags.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'layout',
		component: layout,
		redirect: '/index',
		children: [{
				path: '/index',
				name: 'index',
				component: index,
				meta: {
					title: '大德拍卖-主页'
				}
			},
			{
				path: '/one',
				name: 'one',
				component: one,
				meta: {
					title: '大德拍卖-公益拍卖'
				}
			},
			{
				path: '/guide',
				name: 'guide',
				component: paper,
				meta: {
					title: '大德拍卖-拍卖指南'
				}
			},
			{
				path: '/paper',
				name: 'paper',
				component: paper,
				meta: {
					title: '大德拍卖-法规资讯'
				}
			},
			{
				path: '/essay',
				name: 'essay',
				component: essay,
				meta: {
					title: '大德拍卖-详情'
				}
			},
			{
				path: '/advance',
				name: 'advance',
				component: scene,
				meta: {
					title: '大德拍卖-拍卖预告'
				}
			},
			{
				path: '/scene',
				name: 'scene',
				component: scene,
				meta: {
					title: '大德拍卖-拍卖现场'
				}
			},
			{
				path: '/result',
				name: 'result',
				component: scene,
				meta: {
					title: '大德拍卖-拍卖现场'
				}
			},
			{
				path: '/about',
				name: 'about',
				component: about,
				meta: {
					title: '大德拍卖-关于我们'
				}
			},
			{
				path: '/auction',
				name: 'auction',
				component: auction,
				meta: {
					title: '大德拍卖-商品详情'
				}
			},
			{
				path: '/payment',
				name: 'payment',
				component: payment,
				meta: {
					title: '大德拍卖-选择支付方式'
				}
			},
			{
				path: '/wechat',
				name: 'wechat',
				component: wechat,
				meta: {
					title: '大德拍卖-微信支付'
				}
			},
			{
				path: '/success',
				name: 'success',
				component: success,
				meta: {
					title: '大德拍卖-支付成功'
				}
			}
		]
	}, {
		path: '/register',
		name: 'register',
		component: register,
		meta: {
			title: '大德拍卖-注册账号'
		}
	}, {
		path: '/realname',
		name: 'realname',
		component: realname,
		meta: {
			title: '大德拍卖-实名认证'
		}
	}, {
		path: '/forget',
		name: 'forget',
		component: forget,
		meta: {
			title: '大德拍卖-忘记密码'
		}
	}, {
		path: '/agreement',
		name: 'agreement',
		component: agreement,
		meta: {
			title: '大德拍卖-协议'
		}
	},
	{
		path: '/space',
		name: 'space',
		component: space,
		redirect: '/record',
		children: [{
				path: '/record',
				name: 'record',
				component: record,
				meta: {
					title: '大德拍卖-我的拍卖'
				}
			},
			{
				path: '/collection',
				name: 'collection',
				component: collection,
				meta: {
					title: '大德拍卖-我的数字藏品'
				}
			},
			{
				path: '/detail',
				name: 'detail',
				component: detail,
				meta: {
					title: '大德拍卖-藏品详情'
				}
			},
			{
				path: '/footprint',
				name: 'footprint',
				component: footprint,
				meta: {
					title: '大德拍卖-我的足迹'
				}
			},
			{
				path: '/setting',
				name: 'setting',
				component: setting,
				meta: {
					title: '大德拍卖-账户设置'
				}
			},
			{
				path: '/particular',
				name: 'particular',
				component: particular,
				meta: {
					title: '大德拍卖-订单详情'
				}
			},
			{
				path: '/security',
				name: 'security',
				component: security,
				meta: {
					title: '大德拍卖-保证金详情'
				}
			}
		]
	},
	{
		path: '/phone',
		name: 'phone',
		component: phone,
		meta: {
			title: '大德拍卖-绑定手机号'
		}
	},
	{
		path: '/email',
		name: 'email',
		component: email,
		meta: {
			title: '大德拍卖-绑定邮箱'
		}
	}, {
		path: '/password',
		name: 'password',
		component: password,
		meta: {
			title: '大德拍卖-修改密码'
		}
	}, {
		path: '/address',
		name: 'address',
		component: address,
		meta: {
			title: '大德拍卖-编辑收货地址'
		}
	}, {
		path: '/7129426285db77c6',
		name: '7129426285db77c6',
		component: admlogin,
		meta: {
			title: '大德拍卖-后台登录'
		}
	}, {
		path: '/manage',
		name: 'manage',
		component: manage,
		redirect: '/database',
		children: [{
				path: '/database',
				name: 'database',
				component: database,
				meta: {
					title: '大德拍卖-后台管理首页'
				}
			},
			{
				path: '/account',
				name: 'account',
				component: account,
				meta: {
					title: '大德拍卖-系统用户'
				}
			},
			{
				path: '/users',
				name: 'users',
				component: users,
				meta: {
					title: '大德拍卖-注册用户'
				}
			},
			{
				path: '/commodity',
				name: 'commodity',
				component: commodity,
				meta: {
					title: '大德拍卖-数字藏品'
				}
			},
			{
				path: '/compile',
				name: 'compile',
				component: compile,
				meta: {
					title: '大德拍卖-藏品编辑'
				}
			},
			{
				path: '/classify',
				name: 'classify',
				component: classify,
				meta: {
					title: '大德拍卖-藏品分类'
				}
			},
			{
				path: '/tags',
				name: 'tags',
				component: tags,
				meta: {
					title: '大德拍卖-藏品标签'
				}
			},
			{
				path: '/activity',
				name: 'activity',
				component: activity,
				meta: {
					title: '大德拍卖-拍卖活动'
				}
			},
			{
				path: '/activityedit',
				name: 'activityedit',
				component: activityedit,
				meta: {
					title: '大德拍卖-拍卖活动编辑'
				}
			},
			{
				path: '/item',
				name: 'item',
				component: item,
				meta: {
					title: '大德拍卖-拍卖管理'
				}
			},
			{
				path: '/attention',
				name: 'attention',
				component: attention,
				meta: {
					title: '大德拍卖-用户关注'
				}
			},
			{
				path: '/itemedit',
				name: 'itemedit',
				component: itemedit,
				meta: {
					title: '大德拍卖-拍卖编辑'
				}
			},
			{
				path: '/order',
				name: 'order',
				component: order,
				meta: {
					title: '大德拍卖-订单管理'
				}
			},
			{
				path: '/orderDetail',
				name: 'orderDetail',
				component: orderDetail,
				meta: {
					title: '大德拍卖-订单详情'
				}
			},
			{
				path: '/earnest',
				name: 'earnest',
				component: earnest,
				meta: {
					title: '大德拍卖-定金管理'
				}
			},
			{
				path: '/swiper',
				name: 'swiper',
				component: swiper,
				meta: {
					title: '大德拍卖-轮播管理'
				}
			},
			{
				path: '/article',
				name: 'article',
				component: article,
				meta: {
					title: '大德拍卖-文章管理'
				}
			},
			{
				path: '/issue',
				name: 'issue',
				component: issue,
				meta: {
					title: '大德拍卖-文章编辑'
				}
			},
			{
				path: '/category',
				name: 'category',
				component: category,
				meta: {
					title: '大德拍卖-文章分类'
				}
			},
			{
				path: '/config',
				name: 'config',
				component: config,
				meta: {
					title: '大德拍卖-网站设置'
				}
			}
		]
	}, {
		path: '/notFound',
		name: 'notFound',
		component: notFound,
		meta: {
			title: '大德拍卖-找不到页面'
		}
	},
	{
		path: '*',
		redirect: '/notFound'
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.afterEach(() => {
	window.scrollTo(0, 0);
});

export default router
